import { Skeleton } from "@/components/ui/skeleton";

export function RewardsCardSkeleton() {
  return (
    <div className="border-0 shadow-sm bg-white rounded-lg p-4">
      <div className="flex flex-col gap-2">
        {/* Icon skeleton */}
        <Skeleton className="h-6 w-6 sm:h-7 sm:w-7" />
        
        {/* Value skeleton */}
        <Skeleton className="h-8 sm:h-9 w-20" />
        
        {/* Title skeleton */}
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
  );
}
